import * as Yup from 'yup';

export const updateStatusValidationSchema = Yup.object().shape({
  newStatus: Yup.string().required('Please select a status'),
});
